import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import firebase from 'firebase/app';
import 'firebase/auth';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFirestore, AngularFirestoreDocument } from '@angular/fire/firestore';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { User } from './user.model';
import { stringify } from '@angular/compiler/src/util';
import { Timestamp } from 'rxjs/internal/operators/timestamp';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  user$: Observable<any>;
  isLoggedIn = false
  uid: string;

  constructor(
    private afAuth: AngularFireAuth,
    private afs: AngularFirestore,
    private router: Router) {
      this.user$ = this.afAuth.authState.pipe(
        switchMap(user => {
          if(user) {
            this.uid = user.uid;
            return this.afs.doc(`users/${user.uid}`).valueChanges();
          } else {
            return of(null);
          }
        })
      );
    }


  async forgotPassword(email:string) {
    this.afAuth.sendPasswordResetEmail(email)
    .then( resp => window.alert("Check your Mail box"))
    .catch( error => window.alert(error.message) );
  }

  async signin(email: string, password : string){
    await this.afAuth.signInWithEmailAndPassword(email,password)
    .then(res=>{
      return this.router.navigate(['/']);
    }).catch((error) => {
      window.alert(error.message);
    })
  }

  async signup(name: string, email: string, password : string){
    await this.afAuth.createUserWithEmailAndPassword(email,password)
    .then(res=>{
      const user = {
        'uid': res.user.uid,
        'email': res.user.email,
        'displayName': name,
        'emailVerified': res.user.emailVerified,
        'photoURL': res.user.photoURL,
        'phoneNumber': null,
        'createdAt': firebase.firestore.Timestamp.now()
      };
      this.updateUserData(user).then(() => {
        return this.router.navigate(['/create-profile']);
      });
    }).catch((error) => {
      window.alert(error.message)
    })
  }

  async googleSignIn() {
    const provider = new firebase.auth.GoogleAuthProvider();
    const credential = await this.afAuth.signInWithPopup(provider);
    this.updateUserData(credential.user);
    if(credential.additionalUserInfo.isNewUser) {
      return this.router.navigate(['/create-profile']);
    }
    return this.router.navigate(['/']);
  }

  async signOut() {
    await this.afAuth.signOut();
    return this.router.navigate(['/login']);
  }

  async updateUserData({uid, displayName, email, photoURL, emailVerified, phoneNumber}) {
    const userRef: AngularFirestoreDocument<User> = this.afs.doc(`users/${uid}`);

    var createdAt = firebase.firestore.Timestamp.now();

    const data:User = {
      uid, displayName, email, photoURL, emailVerified, phoneNumber, createdAt
    }
    return userRef.set(data, {merge: true});
  }

  async createUserProfile(
    displayName?: string,
    currently_studying?: string,
    want_to_study?: string,
    when_to_study?: string,
    phoneNumber?: string
  ) {
    const itemsRef = this.afs.collection('users').doc(this.uid);
    await itemsRef.update({
      'displayName': displayName,
      'currently_studying': currently_studying,
      'want_to_study': want_to_study,
      'when_to_study'  :when_to_study,
      'phoneNumber': phoneNumber,
      'schema_version': 0.1
    }).then(() => {
      console.log("Success")
      return this.router.navigate(['/']);
    });
  }

}
